/* Pincode master + reverse indexes + per-partner zone mapping (verbatim from mockup core.js).
   Used by M4 Zone Mapper/Override and the onboarding Courier Zones step. */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_PINCODES = SUPPLY_DATA.pincodes
export const PIN_BY_CITY = SUPPLY_DATA.pinsByCity
export const PIN_BY_STATE = SUPPLY_DATA.pinsByState

/* per-partner zone mapping store — what "Replicate for Parent" inherits.
   pins = pickup-pincode coverage of the loaded master file; dist = % share of zones 1-5. */
export const PARTNER_ZONES = SUPPLY_DATA.partnerZones

export const WAREHOUSES = SUPPLY_DATA.warehouses

export const METROS_DEFAULT = SUPPLY_DATA.metros
export const SPECIALS = SUPPLY_DATA.specials
